export class UrlConstants {
    static API_V2 = "api/v2/";
    static API_UNSECURED_V2 = "apiunsecured/v2/";
    static SIGNAL_R_HUB_SUFFIX = "notifyHub";
    static GEO_PROCESSING = "Geoprocessing";
    static GET_TRUE_CENTROID = "GetTrueCentroid";
    static EXECUTE = "execute";
    static GP_SERVER = "GPServer";
}
